<template>
	<div class="ASNDetail componetself" v-loading="pageload || unvailLoad">
		<div class="body_btns headbtn">
			<vxe-button type="text" class="tool-btn _icon_button" title="选择采购订单" @click="GetPurshModal"
				:disabled="filterForm['_status'] == 4" v-if="!IsCGY && !hasplan">
				<i class="iconfont icon-search iconSize "></i>选择采购订单
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="选择到货计划" @click="GetPurshModal"
				:disabled="filterForm['_status'] == 4" v-if="!IsCGY && hasplan">
				<i class="iconfont icon-search iconSize "></i>选择到货计划
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="行删除" @click="line_delete"
				:disabled="filterForm['_status'] == 4" v-if="!IsCGY">
				<i class="iconfont icon-editor-row-delete iconSize "></i>行删除
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="保存" :loading="SaveLoad"
				:disabled="SaveLoad || filterForm['_status'] == 4" @click="saveASNDatil" v-if="!IsCGY">
				<i class="iconfont icon-save iconSize "></i>保存
			</vxe-button>
			<!-- <vxe-button type="text" class="tool-btn _icon_button" title="标签打印"
				:loading="VDAPRILoad" @click="showCreateModal(true)"
				:disabled="ASNFINTERID||filterForm['_status']==4||VDAPRILoad" v-if="!IsCGY"
				>
				<i class="iconfont icon-print iconSize "></i>标签打印
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="已生成标签查看"
				:loading="VDAPRCreated&&cload" @click="VDAPRCreatedFn"
				:disabled="ASNFINTERID||filterForm['_status']==4||(VDAPRCreated&&cload)"
				>
				<i class="iconfont icon-print iconSize "></i>已生成标签查看
			</vxe-button> -->
			<!-- zr 选择模板打印 -->
			<vxe-button type="text" class="tool-btn _icon_button" title="选择模板打印" @click="showCreateModalT(true)"
				:disabled="ASNFINTERID || filterForm['_status'] == 4 || SBLoad">
				<i class="iconfont icon-print iconSize "></i>选择模板打印
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="作废送货单" :loading="unvailLoad" @click="unvailReq"
				:disabled="ASNFINTERID || filterForm['_status'] == 4 || unvailLoad" v-if="!IsCGY">
				<i class="iconfont icon-shanchu iconSize "></i>作废送货单
			</vxe-button>
		</div>
		<div class="componet_header">

			<div class="filter">
				<template v-for="(item, index) in ASNHead">
					<div class="filter_item" :key="index">
						<c-filter :item="item" :form="filterForm" :line="true" :textMini="90"
							@changeValue="changeFilterValue" :IsForm="true" :VailShow="filterShow"></c-filter>
					</div>
				</template>
			</div>
		</div>
		<div class="componet_body">
			<!-- <div class="body_btns">
				<vxe-button type="text" class="tool-btn _icon_button" 
					title="删除">
					<i class="iconfont icon-shanchu iconSize "></i>行删除
				</vxe-button>
			</div> -->
			<div class="body_content">
				<c-table key="0" ref="ctablemain" :table="table" :coltype="'checkbox'" :calculate="false"
					@listenToChild="listenToChild_mainData" @FitColumns="table.head = $event"></c-table>

			</div>
		</div>
		<vxe-modal ref="CreateModal" title="生成标签" :zIndex="2000" :loading="createLabelLoad" width="90%" height="60%"
			remember>
			<template v-slot:header>
				<vxe-button type="text" class="tool-btn _icon_button" title="行删除" @click="labeldeleteLine"
					v-show="activeName == 'first'" :disabled="createCode.isCreated">
					<i class="iconfont icon-shanchu iconSize "></i>行删除
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="生成标签" v-show="activeName == 'first'"
					:loading="createLoad" @click="CREATElabelfn"
					:disabled="createLabelLoad || createLoad || createCode.isCreated">
					<i class="iconfont icon-create iconSize "></i>生成标签
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="标签打印" v-show="activeName != 'first'"
					:loading="printLoad" @click="labelPrint" :disabled="createLabelLoad || printLoad">
					<i class="iconfont icon-print iconSize "></i>标签打印
				</vxe-button>
				<!-- <vxe-button type="text" class="tool-btn _icon_button" title="作废标签" @click="UNVAILVADA"
					v-show="activeName!='first'" :loading="UNVAILVDALOAD" 
					:disabled="createLabelLoad||UNVAILVDALOAD">
					<i class="iconfont icon-shanchu iconSize "></i>作废标签
				</vxe-button> -->
				<vxe-button type="text" class="tool-btn _icon_button" title="退出" :disabled="createLabelLoad"
					@click="showCreateModal(false)">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<el-tabs ref="eltabs" v-model="activeName" @tab-click="TABCHANGE">
					<el-tab-pane label="标签打印信息" name="first"></el-tab-pane>
					<el-tab-pane label="本次生成标签" name="second"></el-tab-pane>
					<!-- <el-tab-pane label="历史已生成标签" name="third"></el-tab-pane> -->
				</el-tabs>
				<!-- {{createCode.key}}/{{createCode.key+1}}/{{createCode.key+2}} -->
				<el-main class="pursh_main asnDeatail_createdLabel" style="height: calc(100% - 2.8rem);">
					<c-table v-if="activeName == 'first'" ref="ctablecreate" key="1" :table="createCode.table"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div" @listenToChild="listenToChild" coltype="seq">
					</c-table>
					<c-table v-if="activeName == 'second'" ref="ctablecreated" key="2" :table="createCode.tabled"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div" coltype="seq">
					</c-table>
					<!-- <c-table v-if="activeName=='third'" ref="ctablecreatedList"
						key="3"
						:table="createCode.tableList"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						@listenToChild="listenToChild" class="table_height print_selecttable_div"
						coltype="checkbox" >
					</c-table> -->
				</el-main>
			</template>
		</vxe-modal>
		<!-- zr 选择打印模板 -->
		<vxe-modal ref="CreateModalTemplate" title="选择打印模板" :zIndex="2000" :loading="createLabelLoad" width="30%"
			height="30%" remember>
			<template v-slot:header>
				<vxe-button type="text" class="tool-btn _icon_button" title="送货单打印" :loading="SBLoad" @click="SBPrint"
					:disabled="ASNFINTERID || filterForm['_status'] == 4 || SBLoad">
					<i class="iconfont icon-print iconSize "></i>送货单打印
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出" :disabled="createLabelLoad"
					@click="showCreateModalT(false)">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<!-- zr 标签模板 -->
				<span class="filter_item flex flex_row flex-nowrap flex-vc" style="display: inline;">
					<span>送货单打印模板</span>
					<el-select v-model="printMoudle">
						<el-option v-for="(item, index) in moduleList" :key="index" :value="item['FTNumber']"
							:label="item['FTName']"></el-option>
					</el-select>
				</span>

			</template>
		</vxe-modal>
		<vxe-modal ref="CreatedModal" title="已生成标签查看" :zIndex="2000" :loading="createLabelLoad" width="90%" height="60%"
			remember>
			<template v-slot:header>
				<vxe-button type="text" class="tool-btn _icon_button" title="标签打印" :loading="printLoad"
					@click="labelPrint" :disabled="createLabelLoad || printLoad">
					<i class="iconfont icon-print iconSize "></i>标签打印
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="作废标签" @click="UNVAILVADA"
					:loading="UNVAILVDALOAD" :disabled="createLabelLoad || UNVAILVDALOAD" v-if="!IsCGY">
					<i class="iconfont icon-shanchu iconSize "></i>作废标签
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出" :disabled="createLabelLoad"
					@click="VDAPRCreatedFnClose">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<el-main class="pursh_main" style="height: calc(100% - 1.6rem);">
					<c-table ref="ctablecreatedList" key="3" :table="createCode.tableList"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit" @listenToChild="listenToChild"
						class="table_height print_selecttable_div" coltype="checkbox">
					</c-table>
				</el-main>
			</template>
		</vxe-modal>
		<vxe-modal ref="CreatedZTModal" title="已生成托条码查看" :zIndex="2000" :loading="createZTLabelLoad" width="90%"
			height="60%" remember>
			<template v-slot:header>
				<vxe-button type="text" class="tool-btn _icon_button" title="托条码打印" :loading="ztCodeprintLoad"
					@click="ztCodePrint" :disabled="createLabelLoad || ztCodeprintLoad">
					<i class="iconfont icon-print iconSize "></i>托条码打印
				</vxe-button>
				<!-- <vxe-button type="text" class="tool-btn _icon_button" title="作废标签" @click="UNVAILVADA"
					:loading="UNVAILVDALOAD" 
					:disabled="createLabelLoad||UNVAILVDALOAD" v-if="!IsCGY">
					<i class="iconfont icon-shanchu iconSize "></i>作废标签
				</vxe-button> -->
				<vxe-button type="text" class="tool-btn _icon_button" title="退出"
					:disabled="createLabelLoad || ztCodeprintLoad" @click="ZTFnClose">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<el-main class="pursh_main" style="height: calc(100% - 1.6rem);">
					<c-table ref="ctablecreatedztList" key="3" :table="createZTtable"
						style="height: calc(100% - 1.6rem);" @FitColumns="createZTtable.head = $event"
						@listenToChild="createZTtable.checkList = ($event && $event['checkList']) || []"
						class="table_height print_selecttable_div" coltype="checkbox">
					</c-table>
				</el-main>
			</template>
		</vxe-modal>
		<!-- 选择采购订单 -->
		<select-modal ref="selectItem" :table="addItem" :mutiselect="true" @confirm="selectedPurshSource" width="80%"
			@listenToChild="listenToChild_mainData($event, 'select')" @FitColumns="addItem.head = $event"
			@clear="addItem.data = []" :load="selectload" :selectable="selectable" :colfilter="true">
		</select-modal>

	</div>
</template>

<script>
	import {
		head,
		bodyhead
	} from './asncol.js';
	import deepClone from '../../util/Project/common/deepClone.js';
	export default {
		props: {
			menuId: {
				type: String,
				default: ''
			}
		},
		watch: {
			activeName() {
				this.createCode.rowClick = {};
				this.createCode.checkList = [];
				this.createCode.key = Math.random(0, 1);
			}
		},
		data() {
			return {
				filterForm: {},
				table: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
					rowClick: {}
				},
				addItem: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: []
				},
				createZTtable: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
					checkList: []
				},
				ztCodeprintLoad: false,
				zload: false,
				ztModalLoad: false,
				createZTLabelLoad: false,
				selectload: false,
				pageload: false,
				SaveLoad: false,
				FISADD: false, //false 为更新 true 为新增
				colDataTemp: {},
				VDAPRILoad: false,
				VDAPRCreated: false,
				CreatePalletLoad: false,
				cload: false,
				SBLoad: false,
				unvailLoad: false,
				createLabelLoad: false,
				createLoad: false,
				activeName: 'first',
				printLoad: false,
				UNVAILVDALOAD: false,
				createCode: {
					isCreated: false,
					key: 0,
					table: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					tabled: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					tableList: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					tempData: [], //生成标签返回值
					rowClick: {},
					checkList: []
				},
				ASNHead: [],
				Last_Doc: '02', //02 采购订单 03 到货计划
				hasplan: false,
				showTableData: {},
				moduleList: [],
				printMoudle: ''
			}
		},
		computed: {
			ASNFINTERID() {
				//保存后的内码 用于标记是否可以后续的操作
				return !this.filterForm['_id'];
			},
			//ASNHead(){
			//	let headTemp=JSON.parse(JSON.stringify(head));
			//	//如果是提交状态的话 就需要改成不能修改的
			//	if(this.filterForm['_status']==1||this.IsCGY){
			//		for(let i in headTemp){
			//			headTemp[i]['disabled']=true;
			//		}
			//	}
			//	//如果是供应商的话 不显示供应商的编号
			//	headTemp=headTemp.filter(item=>{
			//		return !item['priorty']||(item['priorty']==1&&this.userinfo.accountType=='cgy')
			//	})
			//	return headTemp;
			//},
			GetCurrentTab() {
				if (this.menuId == '')
					return {};
				else {
					return this.$store.getters.GetOpenedTabs.find(i => i.menuId == this.menuId);
				}
			},
			GetRouteData() {
				return this.GetCurrentTab.route;
			},
			userinfo() {
				return this.$store.getters.UserInfo;
			},
			IsCGY() {
				return this.userinfo.accountType == 'cgy'
			},
			pageId() {
				let _tab = this.$store.state.openedTabs.filter(tab => tab.menuId == this.menuId);
				if (_tab.length > 0) {
					return (_tab[0].route || {}).pageId;
				}
				return '';
			}
		},
		methods: {
			//--托条码生管理开始
			//托条码生成
			toCreatePallet() {
				try {
					if (this.ASNFINTERID) throw '请先保存数据';
					if (this.CreatePalletLoad) return;
					this.CreatePalletLoad = true
					this.$BH().base.http({
						url: 'Web/CreatePallet',
						data: {
							FUser: this.userinfo.pfnumber,
							FGYSNumber: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							ASNFINTERID: this.filterForm['_id'] || ''
						},
						success: (res) => {
							this.$BH().message(res.data.errmsg);
							let {
								Moudle,
								MoudleData
							} = res.data.value;
							let date = Date.parse(new Date());
							if (!Moudle || !MoudleData) {
								this.$BH().message('模板数据值为空，请联系管理员');
								this.CreatePalletLoad = false;
								return;
							}
							this.$BH().base.http({
								baseUrl: window.__BH.PrintHtmlService.baseUrl,
								url: window.__BH.PrintHtmlService.dataUrl,
								data: {
									moduleData: JSON.stringify(MoudleData),
									name: 'Template',
									moudle: Moudle,
									date,
									machineCode: this.$store.getters.GUID
								},
								success: (res) => {
									let {
										key,
										file
									} = res.data.value;
									window.open(
										`${window.__BH.PrintHtmlService.baseUrl}/Home?name=${key}&locale=zh-CHS`
									);
									if (file != '')
										this.$BH().DownLoadBase64({
											data: {
												base64Str: file,
												name: key + '.pdf'
											},
											loadingcontrol: () => {
												this.CreatePalletLoad = false;
											}
										});
									else this.$BH().message('下载文件错误')
								},
								loadingcontrol: (res) => {
									if (res != 'success')
										this.CreatePalletLoad = false;
								}
							})
						},
						loadingcontrol: (res) => {
							if (res != 'success')
								this.CreatePalletLoad = false;
						}
					})
				} catch (e) {
					this.$BH().message(e);
					this.CreatePalletLoad = false;
				}
			},
			ZTCreatedFn() {
				try {
					if (this.ztModalLoad) return;
					this.ztModalLoad = true;
					this.cload = true;
					this.$refs.CreatedZTModal?.open();
					setTimeout(() => {
						this.GetZTCoded();
					}, 100);
					this.cload = false;
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.ztModalLoad = false;
					this.zload = false;
				}
			},
			ZTFnClose() {
				this.$refs.CreatedZTModal?.close();
				this.createLabelLoad = false;
				this.createZTtable = {
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: [],
					checkList: []
				}
				this.ztModalLoad = false;
				this.zload = false;

			},
			GetZTCoded() {
				try {
					if (this.ASNFINTERID) throw '请先保存数据';
					if (this.createZTLabelLoad) return;
					this.createZTLabelLoad = true
					this.$BH().base.http({
						url: 'Web/GetASN_ZTCode',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FInterID: this.filterForm['_id']
						},
						success: (res) => {
							//this.createZTtable.head = res.data.value.head;
							this.createZTtable.head =
								(res.data.value.head || []).filter(item => !item['allowUser'] || item[
									'allowUser'].split(',').findIndex(jitem => jitem == this.userinfo
									.accountType) > -1);
							this.createZTtable.data = res.data.value.data;
							this.$refs.ctablecreatedztList?.checkColumnChange();
							setTimeout(() => {
								this.$refs.ctablecreatedztList?.forUpdate();
							}, 300);
						},
						loadingcontrol: () => {
							this.createZTLabelLoad = false;
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.createZTLabelLoad = false;
				}
			},
			ztCodePrint() {
				try {
					if (!this.createZTtable.checkList.length) throw '请先选择需要打印的信息行';
					if (this.ztCodeprintLoad) return;
					this.ztCodeprintLoad = true
					this.$BH().base.http({
						url: 'Web/ToZTCodePrint',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FInterID: this.filterForm['_id'],
							checkList: this.createZTtable.checkList
						},
						success: (res) => {
							let templateBase = res.data.value.moudle;
							let date = Date.parse(new Date());
							if (!templateBase) {
								this.$BH().message('模板数据值为空，请联系管理员');
								return;
							}
							let moudData = {
								BarCodeInfo: this.createZTtable.checkList
							};
							if (res.data.value.relatetion) moudData['BarCodeRelation'] = res.data.value
								.relatetion;
							this.$BH().base.http({
								baseUrl: window.__BH.PrintHtmlService.baseUrl,
								url: window.__BH.PrintHtmlService.dataUrl,
								data: {
									moduleData: JSON.stringify(moudData),
									name: 'GYS',
									moudle: templateBase,
									date,
									machineCode: this.$store.getters.GUID
								},
								success: (res) => {
									let {
										key,
										file
									} = res.data.value;
									window.open(
										`${window.__BH.PrintHtmlService.baseUrl}/Home?name=${key}&locale=zh-CHS`
									);
									if (file != '')
										this.$BH().DownLoadBase64({
											data: {
												base64Str: file,
												name: key + '.pdf'
											},
											loadingcontrol: () => {
												this.createLabelLoad = false;
											}
										});
									else this.$BH().message('下载文件错误')
								},
								loadingcontrol: (res) => {
									if (res != 'success')
										this.createLabelLoad = false;
								}
							})
						},
						loadingcontrol: () => {
							this.ztCodeprintLoad = false;
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.ztCodeprintLoad = false;
				}
			},

			//--托条码生管理结束
			//打开采购订单选择的窗口数据
			//和打开到货计划窗口相同 返回数据 需要更换数据源
			GetPurshModal() {
				try {
					if (this.selectload) return;
					if (this.$refs.selectItem) this.$refs.selectItem.open();
					setTimeout(() => {
						this.selectload = true;
					}, 0);
					let url = 'Web/GetASNSource';
					this.$BH().base.http({
						url: url,
						data: {
							FUser: this.userinfo.pfnumber,
							FGYSNumber: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							pageId: this.pageId,
							hasplan: this.filterForm['FSTYPE']
						},
						success: (res) => {
							let {
								head,
								data
							} = res.data.value;
							this.addItem.head = head;
							this.addItem.data = data;
							setTimeout(() => {
								if (this.$refs.selectItem)
									this.$refs.selectItem.changeColumn();
							}, 0);
						},
						loadingcontrol: (res) => {
							this.selectload = false;
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.selectload = false;
				}
			},
			//选中行不重复控制
			selectable(row, index) {
				if (this.table.data && this.table.data.length > 0) {
					// console.log(this.addItem.table.data)
					console.log(this.table.data, row);
					//20230327 之前选择的时候是 按照采购订单选择
					let filtes = []

					filtes = this.table.data.filter(item => {
						return item['_fentryid'] == row['_fentryid'];
					});

					if (filtes.length > 0) return false;
					else return true;
				}
				return true;
			},
			//zr 选择源单
			selectedPurshSource(e) {
				console.log('confirm', e)
				try {
					if (e && e['checkList'] && e['checkList'].length > 0) {
						let len = this.table.data.length;

						let _from = this.table.data[len - 1]?._id || 0;
						// //第一行 进行 表头反写
						// let _thisType=this.filterForm['_cgtype'];
						// let _thisTyped=this.filterForm['_cgtyped'];
						//修改_id
						for (let i in e['checkList']) {
							e['checkList'][i]['_id'] = Number(_from) + Number(i) + 1;
							// if(!_thisType&&i==0){
							// 	_thisType=e['checkList'][i]['_cgtype'];
							// 	_thisTyped=e['checkList'][i]['_cgtyped'];
							// }else if(!_thisType){
							// 	throw '选择数据缺少关键字段，请联系管理员！【_cgtype，_cgtyped】'
							// }else if(_thisType&&_thisType!=e['checkList'][i]['_cgtype']){
							// 	throw '请选择相同类型的订单类型'
							// }
						}
						if (len == 0) {
							// this.filterForm['_cgtype']=_thisType
							// this.filterForm['_cgtyped']=_thisTyped;
							this.filterForm = JSON.parse(JSON.stringify(this.filterForm))
						}
						this.table.data = this.table.data.concat(e['checkList']);
						// 添加新数据,不触发保存
						setTimeout(() => {
							this.$refs.ctablemain?.checkColumnChange();
						}, 0);
					}
				} catch (e) {
					console.log(e)
					this.$BH().message(e);
				}
			},
			listenToChild_mainData(e, isSelect) {
				if (e && e['rowClick']) {
					this.table.rowClick = e['rowClick'];
				} else if (e && e['checkList']) this.table.checkList = e['checkList'];
			},
			//行删除
			line_delete() {
				try {
					console.log(this.table.checkList);
					if (JSON.stringify(this.table.rowClick) == '{}' && this.table.checkList.length == 0)
						throw '请先点击表体表格行去选中';
					this.$BH().confirm("是否删除", (res => {
						if (res == 'confirm') {
							if (this.table.checkList.length > 0) {
								this.table.checkList.forEach(items => {
									let index = this.table.data.findIndex(item => item._id == items._id);
									if (index > -1) {
										//删除单据上的反写
										if (this.table.data.length == 1) {
											this.filterForm = JSON.parse(JSON.stringify(this
												.filterForm))
										}
										this.table.data.splice(index, 1);
										setTimeout(() => {
											this.$refs.ctablemain?.checkColumnChange();
										}, 0);
									}
								})
							} else {
								let index = this.table.data.findIndex(item => item._id == this.table.rowClick[
									'_id']);
								if (index > -1) {
									//删除单据上的反写
									if (this.table.data.length == 1) {
										// this.filterForm['_cgtype']=''
										// this.filterForm['_cgtyped']='';
										this.filterForm = JSON.parse(JSON.stringify(this.filterForm))
									}
									this.table.data.splice(index, 1);
									setTimeout(() => {
										this.$refs.ctablemain?.checkColumnChange();
									}, 0);
								}
							}
						}
						this.table.rowClick = {};
						this.table.checkList = [];

					}))

				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e)
				}
			},
			//已经生成的标签查看
			VDAPRCreatedFn() {
				try {
					if (this.VDAPRCreated) return;
					this.VDAPRCreated = true;
					this.cload = true;
					this.$refs.CreatedModal?.open();
					setTimeout(() => {
						this.GETCREATEDLABELS();
					}, 100);
					this.cload = false;
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.VDAPRCreated = false;
					this.cload = false;
				}
			},
			VDAPRCreatedFnClose() {
				this.$refs.CreatedModal?.close();
				this.createLabelLoad = false;
				this.createCode.tableList = {
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: [],
				}
				this.createCode.checkList = [];
				this.VDAPRCreated = false;
				this.cload = false;

			},
			//作废标签
			UNVAILVADA() {
				try {
					console.log('作废标签')
					if (!this.createCode.checkList.length) throw '请先选择需要作废的标签';
					if (this.UNVAILVDALOAD) return;
					this.UNVAILVDALOAD = true;
					// let arr=(this.createCode.checkList||[]).map(item=>item['_id']);
					this.$BH().base.http({
						url: 'Web/LabeZF',
						data: {
							user: this.userinfo.fnumber,
							rows: this.createCode.checkList
						},
						success: (res) => {
							this.$BH().message('作废成功');
							this.GETCREATEDLABELS();
						},
						loadingcontrol: (res) => {
							this.UNVAILVDALOAD = false;
						}
					})
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.UNVAILVDALOAD = false;
				}

			},
			//zr 模板打印
			SBPrint() {
				try {
					if (this.ASNFINTERID) throw '请先保存数据';
					// if(this.filterForm['_status']!=1) throw '请先提交';
					if (this.SBLoad) return;
					this.SBLoad = true;
					this.$BH().base.http({
						url: 'Web/GetSLTemplate',
						data: {
							FINTERID: this.filterForm['_id'] || '',
							strUser: this.userinfo.pfnumber,
							pageId: this.pageId,
							FType: this.userinfo.accountType,
							templateNumber: this.printMoudle
						},
						success: (res) => {
							let {
								Moudle,
								MoudleSet
							} = res.data.value;
							let date = Date.parse(new Date());
							if (!Moudle || !MoudleSet) {
								this.$BH().message('模板数据值为空，请联系管理员');
								this.SBLoad = false;
								return;
							}
							this.$BH().base.http({
								baseUrl: window.__BH.PrintHtmlService.baseUrl,
								url: window.__BH.PrintHtmlService.dataUrl,
								data: {
									moduleData: JSON.stringify(MoudleSet),
									name: 'SB',
									moudle: Moudle,
									date,
									machineCode: this.$store.getters.GUID
								},
								success: (res) => {
									let {
										key,
										file
									} = res.data.value;
									window.open(
										`${window.__BH.PrintHtmlService.baseUrl}/Home?name=${key}&locale=zh-CHS`
									);
									if (file != '')
										this.$BH().DownLoadBase64({
											data: {
												base64Str: file,
												name: key + '.pdf'
											},
											loadingcontrol: () => {
												this.SBLoad = false;
											}
										});
									else this.$BH().message('下载文件错误')
								},
								loadingcontrol: (res) => {
									if (res != 'success')
										this.SBLoad = false;
								}
							})
						},
						loadingcontrol: (res) => {
							if (res != 'success')
								this.SBLoad = false;
						}
					})
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.SBLoad = false;
				}
			},
			//标签打印
			//根据查询结果打印
			labelPrint() {
				try {
					//生成标签打印数据
					if (!this.VDAPRCreated)
						this.createCode.checkList = JSON.parse(JSON.stringify(this.createCode.tabled.data));
					if (!this.createCode.checkList.length) throw '请先选择需要打印的信息行';
					if (this.createLabelLoad) return;
					this.createLabelLoad = true;
					this.$BH().base.http({
						url: 'Web/GetLabelTemplate',
						data: {
							strUser: this.userinfo.pfnumber,
							moudleData: this.createCode.checkList
						},
						success: (res) => {
							let templateBase = res.data.value.moudle;
							let date = Date.parse(new Date());
							if (!templateBase) {
								this.$BH().message('模板数据值为空，请联系管理员');
								return;
							}
							this.$BH().base.http({
								baseUrl: window.__BH.PrintHtmlService.baseUrl,
								url: window.__BH.PrintHtmlService.dataUrl,
								data: {
									moduleData: JSON.stringify({
										BarCodeInfo: this.createCode.checkList
									}),
									name: 'GYS',
									moudle: templateBase,
									date,
									machineCode: this.$store.getters.GUID
								},
								success: (res) => {
									let {
										key,
										file
									} = res.data.value;
									window.open(
										`${window.__BH.PrintHtmlService.baseUrl}/Home?name=${key}&locale=zh-CHS`
									);
									if (file != '')
										this.$BH().DownLoadBase64({
											data: {
												base64Str: file,
												name: key + '.pdf'
											},
											loadingcontrol: () => {
												this.createLabelLoad = false;
											}
										});
									else this.$BH().message('下载文件错误')
								},
								loadingcontrol: (res) => {
									if (res != 'success')
										this.createLabelLoad = false;
								}
							})
						},
						loadingcontrol: (res) => {
							if (res != 'success')
								this.createLabelLoad = false;
						}
					})
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.createLabelLoad = false;
				}
			},
			//触发刷新
			TABCHANGE(e) {
				if (e) {
					let {
						paneName
					} = e;
					if (paneName == 'third') {
						this.GETCREATEDLABELS();
					} else
						this.createCode.checkList = []
					if (paneName == 'first' && !this.createCode.isCreated) {
						this.VDADOURCE();
					}
				}
			},
			GETCREATEDLABELS() {
				try {
					if (this.createLabelLoad) return;
					this.createLabelLoad = true;
					this.$BH().base.http({
						url: 'Web/GetASN_CreatedCode',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FInterID: this.filterForm['_id']
						},
						success: (res) => {
							this.createCode.tableList.head = res.data.value.head;
							this.createCode.tableList.data = res.data.value.data;
							this.$refs.ctablecreatedList?.checkColumnChange();
							setTimeout(() => {
								console.log(this.createCode.tableList.head)
								this.$refs.ctablecreatedList?.forUpdate();
							}, 400);
						},
						loadingcontrol: () => {
							this.createLabelLoad = false;
						}
					})
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.createLabelLoad = false;
				}
			},
			//生成标签
			CREATElabelfn() {
				try {
					// console.log(this.createCode.table)
					if (this.createCode.table.data.length == 0) throw '当前无可生成标签的数据';
					//在生成标签以后需要重新再次校验是否超量
					if (this.createCode.isCreated) throw '已经生成标签，不能重复生成';
					//检查是否填写了指定的值
					for (let i in this.createCode.table.data) {
						if (this.createCode.table.data[i]['包装数量'] == '0' || this.createCode.table.data[i]['包装数量'] == '')
							throw '包装数量不允许为空';
						let printNum = this.createCode.table.data[i]['本次打印数量']
						let packNum = this.createCode.table.data[i]['包装数量']
						let Num = Math.ceil(printNum / packNum);
						Num = isNaN(Num) || Num == Infinity ? 0 : Num;
						this.createCode.table.data[i]['本次打印张数'] = Num;
					}
					if (this.createLoad) return;
					this.createLoad = true;
					this.$BH().base.http({
						url: 'Web/CreateGetBRLabel',
						data: {
							user: this.userinfo.pfnumber,
							dtview: this.createCode.table.data,
							FInterID: this.filterForm['_id']
						},
						success: (res) => {
							this.activeName = 'second';
							for (let i in res.data.value.data || []) {
								res.data.value.data[i]['_id'] = i;
							}
							this.createCode.tabled.head = res.data.value.columns;
							this.createCode.tabled.data = res.data.value.data;
							this.createCode.isCreated = true;
							setTimeout(() => {
								this.$refs.ctablecreated?.checkColumnChange();
							}, 0);
						},
						loadingcontrol: () => {
							this.createLoad = false;
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.createLoad = false;
				}
			},
			//获取可以打印的 且已经处理后的数据
			VDADOURCE() {
				try {
					if (this.ASNFINTERID) throw '请先保存数据';
					if (this.createLabelLoad) return;
					this.createLabelLoad = true;
					this.$BH().base.http({
						url: 'Web/GetASN_CodeSource',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FInterID: this.filterForm['_id']
						},
						success: (res) => {
							res.data.value.head.map(item => {
								if (item.name == '包装数量') item.min = '0'
							});
							//this.createCode.table.head = res.data.value.head;
							this.createCode.table.head =
								(res.data.value.head || []).filter(item => !item['allowUser'] || item[
									'allowUser'].split(',').findIndex(jitem => jitem == this.userinfo
									.accountType) > -1);
							this.createCode.table.data = res.data.value.data;
							this.$refs.ctablecreate?.checkColumnChange();
							setTimeout(() => {
								this.createCode.table.head.map(item => {
									if (item.name == '批号') item.width = 130;
								});
								// console.log(this.createCode.table.head)
							}, 500);
						},
						loadingcontrol: () => {
							this.createLabelLoad = false;
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.createLabelLoad = false;
				}
			},
			//zr  打印模板前 先保存修改后的数据
			showCreateModalT(show) {
				try {
					if (show) {
						this.createLabelLoad = true
						this.$refs.CreateModalTemplate.open();
						setTimeout(() => {
							// 获取打印模板
							this.$BH().base.http({
								url: "Web/GetASNTPList",
								data: {
									FUser: this.userinfo.pfnumber,
									gysFUser: this.userinfo.fnumber,
									FType: this.userinfo.accountType,
									pageId: this.pageId
								},
								success: (res) => {
									console.log(res);
									this.moduleList = res.data.value
									this.$nextTick(() => {
										if (this.moduleList.length > 0) {
											this.moduleList.forEach(e => {
												if (e.FDefalut == true) {
													this.printMoudle = e.FTNumber
												}
											});
											if (!this.printMoudle) {
												this.printMoudle = this.moduleList[0].FTNumber
											}
										}
										this.createLabelLoad = false;
									})

								}
							})
						}, 0);
					} else {
						this.$refs.CreateModalTemplate.close();
					}

				} catch (e) {
					this.$BH().message(e);
				}

			},
			showCreateModal(show) {
				if (show) {
					if (this.$refs.CreateModal)
						this.$refs.CreateModal.open();
					setTimeout(() => {
						this.createCode.key = Math.random(0, 1);
						this.VDADOURCE();
					}, 0);
				} else {
					if (this.createLabelLoad) {
						this.$BH().message('正在执行功能中，请稍后关闭');
						return;
					}
					//关闭
					this.activeName = 'first';
					this.createCode = {
						isCreated: false,
						key: 0,
						table: {
							pagesize: 100,
							currentPage: 1,
							head: [],
							data: [],
						},
						tabled: {
							pagesize: 100,
							currentPage: 1,
							head: [],
							data: [],
						},
						tableList: {
							pagesize: 100,
							currentPage: 1,
							head: [],
							data: [],
						},
						tempData: [], //生成标签返回值
						rowClick: {},
						checkList: []
					}
					if (this.$refs.CreateModal)
						this.$refs.CreateModal.close();
				}

			},
			//VDA标签生成 行删除
			labeldeleteLine() {
				try {
					if (JSON.stringify(this.createCode.rowClick) == '{}') throw '请先选择行';
					//删除选中行
					let index = this.createCode.table.data.findIndex(item => {
						return item._id == this.createCode.rowClick._id
					});
					if (index > -1) {
						this.createCode.table.data.splice(index, 1)
						this.createCode.rowClick = {}
					}
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			listenToChild(e) {
				if (e && e['rowClick']) {
					this.createCode.rowClick = e['rowClick'];
				} else if (e && e['checkList']) this.createCode.checkList = e['checkList'];
			},
			//作废
			unvailReq() {
				try {
					if (this.unvailLoad) return;
					this.unvailLoad = true;
					this.$BH().confirm('确定作废当前单据吗', () => {
						if (this.ASNFINTERID) throw '请先保存单据';
						this.$BH().base.http({
							url: 'Web/UNVAILASN',
							data: {
								FInterID: this.filterForm['_id'] || '',
								FUser: this.userinfo.pfnumber,
								gysFUser: this.userinfo.fnumber,
								FType: this.userinfo.accountType,
								FTimeStamp: this.filterForm['_ftimstamp'] || 0,
								pageId: this.pageId
							},
							success: (res) => {
								this.$BH().message(res.data.value);
								this.filterForm['_status'] = 4;
								// this.$store.commit('ChangeTabTitle',{
								// 	title:'ASN发运明细_已作废',
								// 	menuId:this.menuId
								// })
							},
							loadingcontrol: () => {
								this.unvailLoad = false;
							}
						})
					}, () => {
						this.unvailLoad = false;
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.unvailLoad = false;
				}
			},
			//保存单据 更新保存
			saveASNDatil() {
				try {
					if (this.pageload) return;
					this.pageload = true;
					let checkH = () => {
						let mustarr = this.ASNHead.filter(item => item.must);
						for (let i in mustarr) {
							let itemname = mustarr[i]['name'];
							if (!Object.prototype.hasOwnProperty.call(this.filterForm, itemname) ||
								String(this.filterForm[itemname]) == 'undefined' ||
								String(this.filterForm[itemname]) == 'null' ||
								String(this.filterForm[itemname]) == '') {
								throw `${mustarr[i]['Display']}不得为空`;
							}
						}
					}
					let checkB = () => {
						if (this.table.data.length == 0) throw '表体不能为空';
						let mustarr = this.table.head.filter(item => item.must);
						this.table.data.map((row, rowIndex) => {
							mustarr.map(col => {
								let itemname = col['name'];
								let itemtype = col['valueType'];
								if (itemtype == 'bool' && (!Object.prototype.hasOwnProperty.call(row,
											itemname) ||
										String(row[itemname]) == 'undefined' || String(row[
											itemname]) == 'null'))
									row[itemname] = false;
								if (!Object.prototype.hasOwnProperty.call(row, itemname) ||
									String(row[itemname]) == 'undefined' || String(row[itemname]) ==
									'null' || String(row[itemname]) == '')
									throw `第${Number(rowIndex) + 1}行 【${col['title']}】不得为空，请填写`;
							});
						})
					}
					checkH();
					checkB();

					this.$BH().base.http({
						url: 'Web/SaveASNDetail',
						data: {
							ASNH: this.filterForm,
							ASNB: this.table.data,
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							OperType: this.FISADD ? 1 : 2,
							pageId: this.pageId
						},
						success: (res) => {
							let {
								id,
								msg
							} = res.data.value;
							this.$BH().message(msg);
							// let error=value.FERROR;
							if (id) {
								// 	let head=value.ASNDEATIL.Table[0];
								// 	let body=value.ASNDEATIL.Table1;
								// 	if(!head) this.$BH().message("ASN头错误，请联系管理员");
								// 	if(!body) this.$BH().message("ASN头错误，请联系管理员");
								// 	this.filterForm=JSON.parse(JSON.stringify(head));
								// 	this.table.data=JSON.parse(JSON.stringify(body));
								if (this.FISADD) {
									this.filterForm['_id'] = id;
									//更新携带的值
									this.$store.commit('changeRouteData', {
										data: {
											checkOne: {
												_fid: id,
												isadd: false,
											},
											pageId: this.pageId
										},
										menuId: this.menuId
									})
								}
								this.FISADD = false;
								this.$store.commit('ChangeTabTitle', {
									title: '送货单明细页面_修改',
									menuId: this.menuId,
								});
							}
							this.get_refreshDetail(id);
						},
						loadingcontrol: (res) => {
							if (res != 'success')
								this.pageload = false;
						}
					});

					// if(this.FISADD) addRequ();
					// else updateReq();
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.pageload = false;
				}
			},
			//页面初始化数据
			//已经废弃
			initPage() {
				try {
					if (this.pageload) return;
					this.pageload = true;
					this.$BH().base.http({
						url: 'Web/ASNINITPAGE',
						data: {
							ASNFINTERID: this.filterForm['_id'] || '',
							tableData: this.table.data
						},
						success: (res) => {
							let {
								colList,
								transformASNData,
								ASNDEATIL,
								ASNSTATE
							} = res.data.value;
							if (transformASNData) {
								this.table.data = JSON.parse(JSON.stringify(transformASNData));
								delete res.data.value['transformASNData'];
							}
							this.colDataTemp = res.data.value;
							let heads = (item) => {
								let {
									FNUMBER,
									FDEFAULT,
									FDISPLAYCOLNAME,
									FVALUECOLNAME
								} = item;
								let index = head.findIndex(jitem => jitem['name'] == FNUMBER);
								if (index > -1) {
									head[index]['dataSource'] = res.data.value[FNUMBER];
									head[index]['valueName'] = FVALUECOLNAME;
									head[index]['displayName'] = FDISPLAYCOLNAME;
									if (FNUMBER == 'Carrier Code') {
										head[index]['displayName2'] = '承运商名称'
									}
									//试过没有带出值 就是默认值 在后台也有复制
									if (String(this.filterForm[FNUMBER]) == '')
										this.filterForm[FNUMBER] = FDEFAULT;
								}
							}
							let bodys = (item) => {
								let {
									FNUMBER,
									FDEFAULT,
									FDISPLAYCOLNAME,
									FVALUECOLNAME
								} = item;
								let index = this.table.head.findIndex(jitem => jitem['name'] == FNUMBER);
								if (index > -1) {
									this.table.head[index]['dropdata'] = res.data.value[FNUMBER];
									this.table.head[index]['录入值过滤列'] = '物料代码';
									this.table.head[index]['valueName'] = FVALUECOLNAME;
									this.table.head[index]['displayName'] = FDISPLAYCOLNAME;
									this.table.head[index]['itemBoth'] = true;
									this.table.data.map(jitem => {
										if (String(jitem[FNUMBER]) == '')
											jitem[FNUMBER] = FDEFAULT;
									});

								}
							}
							colList.map(item => {
								switch (item['FTYPE']) {
									case 'H':
										heads(item);
										break;
									case 'B':
										bodys(item);
										break;
								}
							});
							console.log(this.table.head)
							//前面有默认值的处理 需要放在最后处理数据
							if (!this.FISADD) {
								if (ASNSTATE && ASNSTATE == '2')
									this.$BH().message('单据已经被删除，关闭详情页面，重新查询列表');
								else if (ASNSTATE) {
									this.filterForm = ASNDEATIL.Table[0];
									this.table.data = ASNDEATIL.Table1;

									// console.log(this.table)
								}
							}
							this.filterForm = JSON.parse(JSON.stringify(this.filterForm));
							console.log(this.filterForm['_status'], this.FISADD)
							if (this.filterForm['_status'] == 1 && !this.FISADD)
								for (let i in this.table.head)
									this.table.head[i]['disabled'] = true;

							if (this.$refs.ctablemain) {
								this.$refs.ctablemain.checkColumnChange();
								setTimeout(() => {
									this.$refs.ctablemain?.forUpdate();
								}, 300);
							}

							// console.log(head,this.ASNHead);
							// console.log(this.table)
						},
						fail: (res) => {
							this.$BH().message(res.data.value);
							this.table.data = [];
						},
						loadingcontrol: () => {
							this.pageload = false;
						}
					})
				} catch (e) {
					this.$BH().message(e);
					this.pageload = false;
				}
			},
			get_refreshDetail(sign) {
				try {
					if (!this.pageload && !sign) return;
					this.pageload = true;
					this.$BH().base.http({
						url: 'Web/GetASNDetail',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							FInterID: sign || this.filterForm['_id'],
							pageId: this.pageId
						},
						success: (res) => {
							console.log(res.data)
							this.filterForm = res.data.value.head[0];
							this.table.data = res.data.value.data || [];
							this.filterForm = JSON.parse(JSON.stringify(this.filterForm));
							this.$refs.ctablemain?.checkColumnChange();
						},
						loadingcontrol: () => {
							this.pageload = false;
						}
					});

				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.pageload = false;
				}
			},
			//表头更改值触发
			changeFilterValue({
				$event,
				filteritem
			}) {
				let {
					name,
					valueName,
					displayName
				} = filteritem;
				if (name == 'Carrier Code') {
					let dropdata = this.colDataTemp[name];
					let {
						colList
					} = this.colDataTemp;
					let jtarget = colList.findIndex(item => item['FNUMBER'] == 'Carrier Name');
					if (jtarget > -1) {
						let jvalueName = colList[jtarget]['FVALUECOLNAME'];
						let target = dropdata.findIndex(item => item[valueName] == $event);
						if (target > -1) this.filterForm['Carrier Name'] = dropdata[target][jvalueName];
						console.log(this.filterForm)
					}

				}
			},
			createFit(e) {
				// console.log('列属性')
				if (this.activeName == 'first') {
					this.createCode.table.head = e;
				} else if (this.activeName == 'second') {
					this.createCode.tabled.head = e;
				} else if (this.VDAPRCreated) {
					this.createCode.tableList.head = e;
				}
				this.createCode.key = Math.random();
			},
			PageInit(callback) {
				try {
					this.pageload = true;
					this.$BH().base.http({
						url: 'Web/GetASNInfo_INIT',
						data: {
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
							pageId: this.pageId
						},
						success: (res) => {
							// console.log(res)
							let {
								value
							} = res.data;
							this.hasplan = value.hasplan;
							let headTemp = JSON.parse(JSON.stringify(value.filterList));
							//如果是提交状态的话 就需要改成不能修改的
							if (this.filterForm['_status'] == 1 || this.IsCGY) {
								for (let i in headTemp) {
									headTemp[i]['disabled'] = true;
								}
							}
							//如果是供应商的话 不显示供应商的编号
							//                     headTemp = headTemp.filter(item => {
							//                         return !item['priorty'] || (item['priorty'] == 1 && this.userinfo.accountType == 'cgy')
							//})
							headTemp = (headTemp || []).filter(item => !item['allowUser'] || item['allowUser']
								.split(',').findIndex(jitem => jitem == this.userinfo.accountType) > -1);
							this.ASNHead = headTemp;
							//this.table.head = value.head;
							this.table.head =
								(value.head || []).filter(item => !item['allowUser'] || item['allowUser']
									.split(',').findIndex(jitem => jitem == this.userinfo.accountType) > -1)
							console.log(callback, this.table.head)
							if (callback) callback(value);
						},
						loadingcontrol: (res) => {
							if (res != 'success')
								this.pageload = false;
							else if (!callback) this.pageload = false;
						}
					})
				} catch (e) {
					this.$BH().message(e);
					this.pageload = false;

				}
			},
			filterShow(filterItem) {
				if (filterItem.allowUser) {
					let users = (filterItem.allowUser || '').split(',');
					let Index = users.findIndex(item => item == this.userinfo.accountType)
					return Index > -1;
				}
				return true;
			}
		},
		mounted() {
			this.PageInit((requestValue) => {
				//新增
				if (this.FISADD) {
					//给定默认值
					// console.log(this.GetRouteData?.order?.head[0])
					// this.filterForm = this.GetRouteData?.order?.head[0];
					this.filterForm = requestValue?.filterData[0];
					this.table.data = JSON.parse(JSON.stringify(this.GetRouteData?.order.body)) || [];

					this.filterForm = JSON.parse(JSON.stringify(this.filterForm));
				} else {
					//修改
					this.filterForm['_id'] = this.GetRouteData?.checkOne?._fid;
					this.filterForm['FSTYPE'] = this.GetRouteData?.checkOne?.FSTYPE;
					if (this.filterForm['FSTYPE'] == 1) this.hasplan = false;
					else this.hasplan = true;
				}
				console.log(this.ASNFINTERID, this.filterForm['_id'], this.GetRouteData)
				if (this.filterForm['_id'])
					this.get_refreshDetail();
				else this.pageload = false;
				// this.initPage();
				setTimeout(() => {
					this.$refs.ctablemain.checkColumnChange();
				}, 0);
			});


		},
		created() {

			//let bodyheadTemp=JSON.parse(JSON.stringify(bodyhead));
			//if(this.IsCGY){
			//	for(let i in bodyheadTemp){
			//		bodyheadTemp[i]['edit']=false;
			//		if(bodyheadTemp[i]['name']=='物料名称') bodyheadTemp[i]['hide']=true;
			//	}
			//}
			//this.table.head=bodyheadTemp;
			console.log(this.GetRouteData)
			this.FISADD = !!this.GetRouteData?.isadd;
			//直接赋值 判断是否进行校验
		}
	}
</script>

<style lang="scss">
	.asnDeatail_createdLabel {

		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
		}

		input[type="number"] {
			-moz-appearance: textfield;
		}
	}
</style>